module.exports = __webpack_public_path__ + "static/media/cod.a0f420c1.png";